import { render, staticRenderFns } from "./transfer-ride-field.vue?vue&type=template&id=61a35227"
import script from "./transfer-ride-field.vue?vue&type=script&lang=js"
export * from "./transfer-ride-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports